export default __webpack_public_path__ + "static/media/remove_devices.8cb36fae.svg";